import { Typography } from "@mui/material"
import { MethodOfPaymentProcess } from "types/paymentMethod.ts"
import React from "react"
import {
    OrevePopup,
    OrevePopupContent,
    OrevePopupTitle,
} from "components/popup/OrevePopup.tsx"
import { Box } from "@mui/system"
import { OreveBlockButton } from "components/OreveBlockButton.tsx"

// POPUP STEP 1 choix du nouveau mode de paiement
export const ChoosePaymentMethod = ({
    onClose,
    isOpen,
    setCurrentProcess,
}: {
    onClose: () => void
    isOpen: boolean
    setCurrentProcess: React.Dispatch<
        React.SetStateAction<MethodOfPaymentProcess | null>
    >
}) => {
    return (
        <OrevePopup open={isOpen} handleClose={onClose}>
            <OrevePopupTitle>
                <Typography variant="headlineSmall">
                    Quel mode de paiement souhaitez-vous ajouter ?
                </Typography>
            </OrevePopupTitle>
            <OrevePopupContent>
                <Box sx={{ display: "flex", gap: "16px" }}>
                    <OreveBlockButton
                        onClick={() => {
                            setCurrentProcess(
                                MethodOfPaymentProcess.ADD_CREDIT_CARD
                            )
                            onClose()
                        }}
                        value="Carte de crédit"
                        sx={{ width: "100px" }}
                    />
                    <OreveBlockButton
                        onClick={() => {
                            setCurrentProcess(
                                MethodOfPaymentProcess.ADD_CURRENT_ACCOUNT
                            )
                            onClose()
                        }}
                        value="IBAN"
                    />
                </Box>
            </OrevePopupContent>
        </OrevePopup>
    )
}
